import { Search, Link, Bell, CheckCircle } from 'lucide-react'

const ServiceDescription = () => {
  const steps = [
    {
      icon: <Search className="w-8 h-8 text-primary" />,
      title: "Find din læge",
      description: "Gå til findlæge.dk og find den læge du gerne vil have. Kopier URL'en fra din browser."
    },
    {
      icon: <Link className="w-8 h-8 text-primary" />,
      title: "Send til vores bot",
      description: "Start en chat med vores Telegram bot og send lægens findlæge URL. Det tager kun 30 sekunder."
    },
    {
      icon: <Bell className="w-8 h-8 text-primary" />,
      title: "Modtag notifikationer",
      description: "Vi checker dagligt om lægen åbner for nye patienter og sender dig en besked med det samme."
    },
    {
      icon: <CheckCircle className="w-8 h-8 text-secondary" />,
      title: "Book tid",
      description: "Når du får notifikationen, kan du hurtigt gå ind og booke en tid hos lægen."
    }
  ]

  return (
    <section className="section-padding bg-white">
      <div className="max-w-6xl mx-auto">
        <div className="text-center mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
            Sådan fungerer det
          </h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Fire simple trin til at få automatiske notifikationer når din ønskede læge åbner for nye patienter
          </p>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
          {steps.map((step, index) => (
            <div key={index} className="text-center relative">
              <div className="card hover:shadow-xl transition-shadow duration-300">
                <div className="bg-blue-50 p-4 rounded-full w-20 h-20 mx-auto mb-6 flex items-center justify-center">
                  {step.icon}
                </div>
                
                <div className="absolute -top-3 -left-3 bg-primary text-white rounded-full w-8 h-8 flex items-center justify-center font-bold text-sm">
                  {index + 1}
                </div>
                
                <h3 className="text-xl font-semibold text-gray-900 mb-4">
                  {step.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed">
                  {step.description}
                </p>
              </div>
              
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-1/2 -right-4 transform -translate-y-1/2">
                  <div className="w-8 h-0.5 bg-gray-300"></div>
                  <div className="absolute right-0 top-1/2 transform -translate-y-1/2 translate-x-1">
                    <div className="w-2 h-2 bg-gray-300 rounded-full"></div>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
        
        <div className="mt-16 text-center">
          <div className="bg-green-50 border border-green-200 rounded-xl p-8 max-w-2xl mx-auto">
            <h3 className="text-2xl font-semibold text-green-800 mb-4">
              Hvorfor vælge vores service?
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4 text-left">
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
                <span className="text-green-700">Daglig overvågning af alle læger</span>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
                <span className="text-green-700">Øjeblikkelige Telegram notifikationer</span>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
                <span className="text-green-700">Ingen personlige data opbevares</span>
              </div>
              <div className="flex items-start space-x-3">
                <CheckCircle className="w-5 h-5 text-green-600 mt-1 flex-shrink-0" />
                <span className="text-green-700">100% gratis - ingen skjulte omkostninger</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  )
}

export default ServiceDescription